import axios from 'axios';
import {config} from '../server/config';
import { multiviewTrayQuerySHA, minifiedMultiviewTrayQuery } from './Graphql/Queries/multiviewTrayQuery';
import logger from './logger';

export async function fetchMultiviewTrayData (variables,url) {
   try {
      return axios.get(url+'?extensions={"persistedQuery":{"version":1,"sha256Hash":'+JSON.stringify(multiviewTrayQuerySHA)+'}}&variables='+JSON.stringify(variables))
      .then((response) => {
         //if persisted query not found 
         let res = response?.data
         if(res.errors) {
            if(res?.errors?.[0]?.message  === "PersistedQueryNotFound") {
               return cacheMultiviewTrayData(variables,url) 
            }
         }
         else{
            let data = res?.data
            return data
         }
      })
      .catch(err => {
         logger(`Multi view error: ${err}`, "error")
         return
      })
   }
   catch (err) {
      return logger(`Multi view error: ${err}`, "error")
   }
}
 /*  
export function cacheMultiviewTrayData (variable,url) {
   let endpoint = `${config.cachedAPI || config.apiBaseUrl}/graphql`
   let finalPayload = {
      "query": minifiedMultiviewTrayQuery,
      "variables": variable,
      "extensions": {
         "persistedQuery": {
               "version": 1,
               "sha256Hash": multiviewTrayQuerySHA
         }
      }
   }
   try{
      return axios.post(endpoint, finalPayload)
         .then(response => {  
            return fetchMultiviewTrayData(variable,url)
         })
         .catch(error => {
               if (error.response) {
                  logger(error.response.data);
               } else {
                  logger('Error', error.message);
               }
         });
   }
   catch(err){
     logger(`Multi view error: ${err}`, "error")
   }
}
*/
export async function cacheMultiviewTrayData(variables, urlForRefetch) {
    try {
        await axios.post(
            `${config.cachedAPI}/graphql`,
            {
                query: minifiedMultiviewTrayQuery,
                variables,
                extensions: {
                    persistedQuery: {
                        version: 1,
                        sha256Hash: multiviewTrayQuerySHA,
                    },
                },
            }
        );
        return await fetchMultiviewTrayData(variables, urlForRefetch);
    } catch (error) {
        if (error.response && error.response.data) {
            logger(error.response.data);
        } else if (error.message) {
            logger('Error', error.message);
        } else {
            logger(`Multi view error: ${error}`, 'error');
        }
    }
}